import { ChangeDetectorRef, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Message, ConfirmationService, ConfirmEventType, MenuItem } from 'primeng/api';
import { DataService } from 'src/app/services/data.service';
import { link, breadcrumb, stat } from 'src/app/admin/layout/header/header.component';
import { GlobalConstants } from 'src/app/services/global-constants';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { cloneDeep } from 'lodash';
import { MsPermissionService } from 'src/app/services/ms-permission.service';

@Component({
  selector: 'app-ms-factor',
  templateUrl: './ms-factor.component.html',
  styleUrls: ['./ms-factor.component.scss', '../../../../mystery-shopper/mystery-shopper.component.scss']

})
export class MsFactorComponent {
  isInternalPM: boolean = false;

  stepCriteria: number = 1;
  header: string = this.translate("Enquiries");
  links: link[] = [
    {
      name: this.translate('Back'),
      icon: 'pi pi-refresh',
      link: '/ms/criterias',
    }
  ];
  breadcrumbs: breadcrumb[] = [
    { name: this.translate('Project'), link: '/ms/project' },
    { name: this.translate('Enquiries'), link: '/ms/factor' },
  ];

  skelition: boolean = true;
  projectId: string = '';
  messages: Message[] = [];
  channels: any;
  project: any;
  selectedBranches: any;
  basicChannels: any;
  factors: any;
  isUpdate: boolean = false;
  locationOrigin: string = location.origin;

  enquiry: {
    "_id"?: string,
    "projectId"?: string,
    "factorId"?: any,
    "enquiry"?: string,
    "correctAnswer"?: string,
    "serviceUrl"?: string,
    "approvalStatus"?: string,
    "comments"?: string
  } = {}
  enquiries: any;
  pmComment: string = '';
  stepStatus: any = [];
  statusType: string = '';
  hasStatusDB: boolean = true;
  showSelectServiceModal: boolean = false;


  constructor(
    private route: ActivatedRoute,
    private dataService: DataService,
    private router: Router,
    private confirmationService: ConfirmationService
  ) { }

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }

  ngOnInit() {


    this.route.params.subscribe(params => {
      this.projectId = params['projectId'];
      this.links[0].link = '/ms/criterias/' + this.projectId;
      if (this.projectId) {
        Promise.all([
          this.getProject(this.projectId).then(() => {
            let pm = MsPermissionService.checkUserPermissions(this.project);
            if (pm == true) {
              this.isInternalPM = true;
            } else if (pm == false) {
              this.router.navigate(['/ms/project'])
              return;
            }

            this.getStepStatus()
          }),
          this.getFactors(),
          this.getEnquiries(),
        ]).then(() => { this.skelition = false })
      }
    })
  }

  async getProject(id: string) {
    try {
      this.skelition = true;
      let res = await this.dataService.getData(`ms-project/${id}`)
      if (res.error) {
        console.log(res.error);
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.project = res.data.data;
      this.channels = res.data.channels.filter((item: any) => item.type == 'Basic')
      this.selectedBranches = res.data.channels.filter((item: any) => item.type == 'Branch')
      this.basicChannels = res.data.channels.filter((item: any) => item.type == 'Basic')
      this.skelition = false;
    } catch (e: any) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: e.toString() },
      ]
    }
  }

  toggleAnswerVisibility(enquiry: any) {
    enquiry.showFullAnswer = !enquiry.showFullAnswer;
  }

  async getFactors() {
    try {
      let res = await this.dataService.getData(`ms-factors/1/1000/${this.projectId}`)
      if (res.error) {
        console.log(res.error);
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.factors = res.data;
      console.log('FACTORS', this.factors);
    } catch (e: any) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: e.toString() },
      ]
    }
  }

  updateEnquiry(enquiry: any) {
    if (this.enquiry == enquiry) {
      this.enquiry = {};
      this.isUpdate = false;
    } else {
      this.enquiry = cloneDeep(enquiry);
      this.enquiry.factorId = this.enquiry.factorId._id
      this.isUpdate = true;
    }
    console.log(this.enquiry)
  }

  async postEnquiry() {
    if (this.enquiry.correctAnswer && this.enquiry.enquiry && this.enquiry.factorId && this.enquiry.serviceUrl) {
      try {
        this.skelition = true;

        this.enquiry.projectId = this.projectId;
        let url = `ms-enquiry`;
        if (this.isUpdate) {
          url += `/${this.enquiry._id}`
        }
        let res = await this.dataService.postData(url, this.enquiry, this.isUpdate ? 'PUT' : 'POST')
        if (res.error) {
          console.log(res.error);
          this.messages = [
            { severity: 'error', summary: this.translate('error'), detail: res.msg },
          ]
          return;
        }
        this.enquiry = {};
        this.getEnquiries();
        this.getStepStatus();
        this.skelition = false;
        this.isUpdate = false;
      } catch (e: any) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: e.toString() },
        ]
      }
    }
  }
  async getEnquiries() {
    try {
      let res = await this.dataService.getData(`ms-enquiry/project/1/1000/${this.projectId}`)
      if (res.error) {
        console.log(res.error);
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ]
        return;
      }
      this.enquiries = res.data;
      console.log('ENQUIRIES', this.enquiries);
    } catch (e: any) {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: e.toString() },
      ]
    }
  }

  async getStepStatus() {
    try {
      let vendorType = (this.isInternalPM || this.isInternalUserPM(this.project.internalPm)) ? 'internal' : 'external';
      let res = await this.dataService.getData('ms-step/project/' + this.projectId + '/Enquiries/' + vendorType);
      if (res.error) {
        this.hasStatusDB = false;
        return
      }
      this.stepStatus = res.data;

      if (this.stepStatus) {
        this.statusType = this.stepStatus.approvalStatus;
        if (this.statusType == 'Redo' || this.statusType == 'Change') {
          this.pmComment = this.stepStatus.comments;
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  approveStatus() {
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: async () => {
        try {
          let approveData: any = {
            projectId: this.projectId,
            approvalStatus: 'Approved',
            comments: this.pmComment,
            step: 'Enquiries',
            doneBy: localStorage.getItem('uid'),
          };
          this.skelition = true;
          let res = await this.dataService.postData('ms-step', approveData);
          if (res.error) {
            this.messages = [
              { severity: 'error', summary: this.translate('error'), detail: res.msg },
            ];
            return;
          }
          this.messages = [
            { severity: 'success', summary: this.translate('success') },
          ];
          this.ngOnInit();
        } catch (error) {
          console.log(error);
        }
      },
    });
  }

  redoStatus() {
    if (this.pmComment == '') {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: this.translate('Please Enter Comments') },
      ];
      return;
    }
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: async () => {
        try {
          let approveData: any = {
            projectId: this.projectId,
            approvalStatus: 'Redo',
            comments: this.pmComment,
            step: 'Enquiries',
            doneBy: localStorage.getItem('uid')
          };
          this.skelition = true;
          let res = await this.dataService.postData('ms-step', approveData);
          if (res.error) {
            this.messages = [
              { severity: 'error', summary: this.translate('error'), detail: res.msg },
            ];
            return;
          }
          this.messages = [
            { severity: 'success', summary: this.translate('success') },
          ];
          this.ngOnInit();
        } catch (error) {
          console.log(error);
        }
      },
    });
  }

  async pendingStatus() {
    try {
      let approveData: any = {
        projectId: this.projectId,
        approvalStatus: 'Pending',
        comments: this.pmComment,
        step: 'Enquiries',
        doneBy: localStorage.getItem('uid'),
      };
      this.skelition = true;
      let res = await this.dataService.postData('ms-step', approveData);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success') },
      ];
      this.ngOnInit();
    } catch (error) {
      console.log(error);
    }
  }

  confirmDelete(id: string) {
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: () => {
        this.deleteEnquiry(id);
      },
    });
  }

  async deleteEnquiry(id: string) {
    try {
      this.skelition = true;
      let res = await this.dataService.deleteData(`ms-enquiry/${id}`)
      if (res.error) {
        this.skelition = false;
        console.log(res.error);
        return;
      }
      this.getEnquiries();
      this.skelition = false;
    } catch (e) {
      console.log(e);
    }
  }

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: 'نعم',
      rejectLabel: 'لا',
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  setServiceLink(service: any) {

    if (service) {
      this.enquiry.serviceUrl = service.id;
    }
    this.showSelectServiceModal = false;
  }

  getServiceURL() {
    if (this.enquiry.serviceUrl != undefined) {
      return this.locationOrigin + '/data/' + this.enquiry.serviceUrl
    }
    else {
      return "";
    }
  }

  submitForApproval() {
    if (this.enquiries.length > 0) {
      this.confirm({
        message: this.translate('Are you sure you want to do this?'),
        header: this.translate('Confirmation message'),
        icon: 'pi pi-exclamation-triangle',
        action: async () => {
          this.pendingStatus();
        },
      });
    }
    else {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: "" },
      ];
      return;
    }
  }

  requestChange() {
    if (this.pmComment == '') {
      this.messages = [
        { severity: 'error', summary: this.translate('error'), detail: this.translate('Please Enter Comments') },
      ];
      return;
    }
    this.confirm({
      message: this.translate('Are you sure you want to do this?'),
      header: this.translate('Confirmation message'),
      icon: 'pi pi-exclamation-triangle',
      action: async () => {
        try {
          let approveData: any = {
            projectId: this.projectId,
            approvalStatus: 'Change',
            comments: this.pmComment,
            step: 'Enquiries',
            doneBy: localStorage.getItem('uid')
          };
          this.skelition = true;
          let res = await this.dataService.postData('ms-step', approveData);
          if (res.error) {
            this.messages = [
              { severity: 'error', summary: this.translate('error'), detail: res.msg },
            ];
            return;
          }
          this.messages = [
            { severity: 'success', summary: this.translate('success') },
          ];
          this.ngOnInit();
        } catch (error) {
          console.log(error);
        }
      },
    });
  }

  isInternalUserPM(internalPm: any) {
    const uid: string = localStorage.getItem('uid') ?? '';
    if (internalPm) {
      if (Array.isArray(internalPm) && internalPm.length > 0) {
        return uid === internalPm[0]._id;
      } else if (typeof internalPm === 'object' && internalPm._id) {
        return uid === internalPm._id;
      }
    }
    return false;
  }
}
